import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { FaPhone } from "react-icons/fa6";
import { FiTrash2 } from "react-icons/fi";
import {
  getContact,
  deleteContact,
  addContact,
} from "../../../Services/projectServices";
import CommonPagination from "./CommonPagination";
import { Spinner, CommonForm, RoleValidator } from "../../../Components/Common";
import {
  avatarColors,
  contact_formFieldLabels,
  contact_renderFieldConfig,
  TOAST_MESSAGES,
  VENDOR_TYPE_CONSTANTS,
} from "../constants";
import { IoMdAddCircle } from "react-icons/io";
import { toProperCase } from "../../../Utils";
import { ROLES } from "../../../Constants/Strings";

const ProjectPointOfContact = ({ project_id, projectData }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactData, setContactData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));
  const [vendorFilter, setVendorFilter] = useState("");
  const formDataDefaultValues = {
    person_name: "",
    mobile: "",
    email: "",
    service_description: "",
    type: "",
  };

  const [formData, setFormData] = useState(formDataDefaultValues);

  const fetchContactDetails = async (page = 1, filter = vendorFilter) => {
    try {
      const params = {
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        type: filter,
      };
      const response = await getContact(project_id, params);
      if (response.status === 200) {
        setTotalCount(response.data.count);
        setContactData(response.data.results);
      } else {
        toast.error(TOAST_MESSAGES.CONTACT_DETAILS_FAILED);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.CONTACT_DETAILS_FAILED);
    }
  };

  useEffect(() => {
    fetchContactDetails(currentPage, vendorFilter);
  }, [currentPage, vendorFilter, projectData]);

  const handleDeleteContact = async (contact_id) => {
    try {
      const response = await deleteContact(project_id, contact_id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.DELETE_CONTACT_SUCCESS);
        fetchContactDetails(currentPage, vendorFilter);
      } else {
        toast.error(TOAST_MESSAGES.CONTACT_DETAILS_FAILED);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.CONTACT_DETAILS_FAILED);
    }
  };

  const handleAddSubmit = async () => {
    try {
      setIsSubmitting(true);
      const response = await addContact(project_id, formData);
      if (response.status === 201) {
        toast.success(TOAST_MESSAGES.ADD_CONTACT_SUCCESS);
        setShowPopup(false);
        fetchContactDetails(currentPage, vendorFilter);
      } else {
        toast.error(TOAST_MESSAGES.FAILED_ADD_CONTACT);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.FAILED_ADD_CONTACT);
    } finally {
      setIsSubmitting(false);
      setFormData(formDataDefaultValues);
    }
  };

  const handleFilterChange = (e) => {
    setVendorFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid = () => {
    return (
      formData.person_name.trim() !== "" &&
      formData.mobile.trim() !== "" &&
      formData.type.trim() !== ""
    );
  };

  return (
    <div className="p-4 bg-white rounded shadow-md mt-4">
      <div className="flex justify-between items-center mb-4 w-full">
        <h2 className="text-md md:text-lg font-semibold">
          Project Point of Contact
        </h2>
        <div className="flex gap-1 items-center justify-center">
          <span className="flex gap-2">
            <label className="">Vendor Type</label>
            <select
              value={vendorFilter}
              onChange={handleFilterChange}
              className="rounded text-xs"
            >
              <option value="">All</option>
              {VENDOR_TYPE_CONSTANTS.map((field, idx) => (
                <option key={idx} value={field.value}>
                  {field.label}
                </option>
              ))}
            </select>
          </span>
          <RoleValidator allowedRoles={[ROLES.ADMIN, ROLES.USER]}>
            <div className="flex gap-2">
              <button
                className="flex gap-2 p-1 text-primary px-4 items-center"
                onClick={() => setShowPopup(true)}
                title="Add Contact"
              >
                <IoMdAddCircle size={20} />
              </button>
            </div>
          </RoleValidator>
        </div>
      </div>

      <div className="rounded w-full ">
        {contactData.length > 0 ? (
          <div className="mx-auto bg-white p-3 overflow-x-scroll">
            {/* <ul className="min-w-[500px] ">
              {contactData.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between border-b last:border-none py-2 px-1"
                >
                  <div className="flex items-center gap-3 w-[30%] min-w-max">
                    <div
                      className={`w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm ${
                        avatarColors[index % avatarColors.length]
                      }`}
                    >
                      {item.person_name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div>
                      <p className="font-semibold text-sm">
                        {item.person_name}
                      </p>
                      <p className="text-xs text-gray-500">{item.email}</p>
                    </div>
                  </div>

                  <div className="flex flex-col text-gray-600 text-xs w-[10%]">
                    <p className="flex gap-1 justify-start items-center">
                      <span className="font-medium">
                        <FaPhone />
                      </span>{" "}
                      {item.mobile}
                    </p>
                  </div>
                  <div className="flex flex-col text-gray-600 text-xs w-[10%]">
                    {item.service_description && (
                      <p className="truncate"> {item.service_description}</p>
                    )}
                  </div>
                  <div className="flex flex-col text-gray-600 text-xs w-[20%]">
                    <span className="text-[10px] bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full w-max">
                      {toProperCase(item.type)}
                    </span>
                  </div>
                  <div className="flex flex-col items-end gap-1 w-[10%]">
                    <RoleValidator allowedRoles={[ROLES.ADMIN, ROLES.USER]}>
                      <button
                        className="text-gray-400 hover:text-red-500 transition text-sm"
                        onClick={() => handleDeleteContact(item.id)}
                      >
                        <FiTrash2 />
                      </button>
                    </RoleValidator>
                  </div>
                </li>
              ))}
            </ul> */}
            <ul className="min-w-[500px]">
              {contactData.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between border-b last:border-none py-2 px-1"
                >
                  {/* Name & Email */}
                  <div className="flex items-center gap-3 w-[200px] min-w-[200px] overflow-hidden">
                    <div
                      className={`w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm ${
                        avatarColors[index % avatarColors.length]
                      }`}
                    >
                      {item.person_name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div className="truncate">
                      <p className="font-semibold text-sm truncate">
                        {item.person_name}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {item.email}
                      </p>
                    </div>
                  </div>

                  {/* Mobile */}
                  <div className="flex flex-col text-gray-600 text-xs w-[120px] min-w-[120px] truncate">
                    <p className="flex gap-1 items-center truncate">
                      <FaPhone /> {item.mobile}
                    </p>
                  </div>

                  {/* Service Description */}
                  <div className="flex flex-col text-gray-600 text-xs w-[150px] min-w-[150px] truncate">
                    {item.service_description && (
                      <p className="truncate">{item.service_description}</p>
                    )}
                  </div>

                  {/* Type */}
                  <div className="flex flex-col text-gray-600 text-xs w-[100px] min-w-[100px]">
                    <span className="text-[10px] bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full w-max truncate">
                      {toProperCase(item.type)}
                    </span>
                  </div>

                  {/* Actions */}
                  <div className="flex flex-col items-end gap-1 w-[60px] min-w-[60px]">
                    <RoleValidator allowedRoles={[ROLES.ADMIN, ROLES.USER]}>
                      <button
                        className="text-gray-400 hover:text-red-500 transition text-sm"
                        onClick={() => handleDeleteContact(item.id)}
                      >
                        <FiTrash2 />
                      </button>
                    </RoleValidator>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="flex justify-center">No contacts Found</div>
        )}
      </div>
      <CommonPagination
        page={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg relative">
            <h2 className="text-lg text-center font-semibold mb-4">
              {" "}
              Add Contact{" "}
            </h2>
            <CommonForm
              formData={formData}
              renderField={contact_renderFieldConfig}
              handleChangeData={handleChange}
              formFieldLabels={contact_formFieldLabels}
              isTwoColumnCss={"w-1/2 px-2"}
              readOnly={false}
            />
            <div className="mt-4 flex justify-end gap-2">
              <button
                onClick={() => setShowPopup(false)}
                className="bg-gray-300 px-4 py-2 rounded disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {" "}
                Cancel{" "}
              </button>

              <button
                onClick={handleAddSubmit}
                className={`px-4 py-2 rounded text-white ${
                  isFormValid()
                    ? "bg-primary hover:bg-secondary"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                disabled={!isFormValid() || isSubmitting}
              >
                {isSubmitting ? <Spinner /> : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectPointOfContact;
